import {Component, OnInit} from '@angular/core';
import {DataService, OrientDBCollectionView} from '@cosbeni/database';
import {ActivePromotionConfig} from '../config/active-promotion.config';

/**
 * 買取屋 マスター管理 (旧 kaitoriya.app /admin `cj-admin-master` の移植)。
 *
 * OrientDB クラス `AP_Master` は買取伝票の各ドロップダウン (買取区分/最終区分/部門/担当者) の
 * ルックアップ表。`value`=表示テキスト、`colorId`(1-11)=カレンダー色、`sort`=並び順。
 * OrientDBCollectionView + `saveChanges()` で一覧・追加・編集・削除する。
 */
@Component({
    standalone: false,
    selector: 'app-kaitoriya-master',
    templateUrl: 'master-management.component.html',
})
export class KaitoriyaMasterManagementComponent implements OnInit {
    masters: OrientDBCollectionView;
    readonly = true;

    constructor(private dataService: DataService) {
        this.masters = new OrientDBCollectionView(this.dataService, ActivePromotionConfig.DATABASE,
            'SELECT FROM AP_Master', 'AP_Master', '', 0, 100, true, true, false);
        this.masters.url = ActivePromotionConfig.SERVER_URL;
        this.masters.tokenName = ActivePromotionConfig.DATABASE + '_token';
    }

    ngOnInit(): void {
        this.masters.filterOnServer = true;
    }
}
